/**
 * Company settings helpers (opening hours, address, phone).
 * Values come from Contenda.settings in globalhead.jsp.
 */
(function (window) {
	'use strict';

	var TZ = 'Europe/Copenhagen';
	var DAY_KEYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
	var DAY_LABELS = ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'];
	var DAY_SHORT = ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'];

	window.Contenda = window.Contenda || {};

	function settings() {
		return (window.Contenda && Contenda.settings) || {};
	}

	function escapeHtml(value) {
		return String(value == null ? '' : value)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}

	function hoursRaw(dayIndex) {
		return String(settings()['opening_hours_' + DAY_KEYS[dayIndex]] || '').trim();
	}

	function parseRange(value) {
		if (!value || /^(lukket|closed)$/i.test(value)) return null;
		var match = value.match(/(\d{1,2}):(\d{2})\s*[-–]\s*(\d{1,2}):(\d{2})/);
		if (!match) return null;
		var start = (+match[1]) * 60 + (+match[2]);
		var end = (+match[3]) * 60 + (+match[4]);
		var label = pad(match[1]) + ':' + match[2] + '–' + pad(match[3]) + ':' + match[4];
		return { start: start, end: end, label: label };
	}

	function pad(n) {
		return String(n).length === 1 ? '0' + n : String(n);
	}

	function nowInCopenhagen() {
		return new Date(new Date().toLocaleString('en-US', { timeZone: TZ }));
	}

	function telHref(phone) {
		return 'tel:' + String(phone || '').replace(/[^\d+]/g, '');
	}

	/* Display form without the country code — the design writes the number as
	   "70 25 25 49" in the hero and on the person card, while tel: links and the
	   address block keep the full +45 number. */
	function phoneShort(phone) {
		return String(phone || '').replace(/^(\+45|0045)\s*/, '').trim();
	}

	function addressLines() {
		var s = settings();
		return {
			street: s.company_street || '',
			zip: s.company_zip || '',
			city: s.company_city || '',
			country: s.company_country || '',
			cvr: s.company_cvr || '',
			name: s.company_name || 'Komunikado'
		};
	}

	function mapsQuery() {
		var a = addressLines();
		return [a.street, (a.zip + ' ' + a.city).trim(), a.country].filter(Boolean).join(', ');
	}

	function weekdaySummary() {
		var monday = parseRange(hoursRaw(1));
		var sameWeekdays = true;
		var i;
		for (i = 2; i <= 5; i++) {
			var range = parseRange(hoursRaw(i));
			if (!monday || !range || range.label !== monday.label) {
				sameWeekdays = false;
				break;
			}
		}
		if (sameWeekdays && monday) {
			return 'Man–fre ' + monday.label;
		}
		return 'Se åbningstider';
	}

	function isOpen() {
		var now = nowInCopenhagen();
		var range = parseRange(hoursRaw(now.getDay()));
		if (!range) return false;
		var minutes = now.getHours() * 60 + now.getMinutes();
		return minutes >= range.start && minutes < range.end;
	}

	/* Listed Monday first — getDay() is Sunday-indexed, which is not how a
	   Danish opening-hours table reads. */
	var WEEK_ORDER = [1, 2, 3, 4, 5, 6, 0];

	function hoursList() {
		var today = nowInCopenhagen().getDay();
		return WEEK_ORDER.map(function (index) {
			var range = parseRange(hoursRaw(index));
			return {
				key: DAY_KEYS[index],
				index: index,
				label: DAY_LABELS[index],
				short: DAY_SHORT[index],
				value: range ? range.label : 'Lukket',
				range: range,
				closed: !range,
				today: index === today
			};
		});
	}

	function openStatus() {
		return isOpen()
			? { open: true, text: 'Åbent' }
			: { open: false, text: 'Lukket' };
	}

	function openDays() {
		return hoursList().filter(function (day) {
			return !day.closed;
		}).map(function (day) {
			return day.index;
		});
	}

	function clockFromMinutes(minutes) {
		return pad(Math.floor(minutes / 60)) + ':' + pad(minutes % 60);
	}

	function nextOpening() {
		var now = nowInCopenhagen();
		var today = now.getDay();
		var minutes = now.getHours() * 60 + now.getMinutes();
		var todayRange = parseRange(hoursRaw(today));
		if (todayRange && minutes < todayRange.start) {
			return { today: true, range: todayRange, dayIndex: today };
		}
		var i;
		for (i = 1; i <= 7; i++) {
			var index = (today + i) % 7;
			var range = parseRange(hoursRaw(index));
			if (range) return { today: false, range: range, dayIndex: index };
		}
		return null;
	}

	function heroMeta() {
		var todayRange = parseRange(hoursRaw(nowInCopenhagen().getDay()));
		if (isOpen() && todayRange) {
			return 'Åbent i dag kl. ' + todayRange.label;
		}
		var next = nextOpening();
		if (!next) return 'Lukket nu';
		var when = next.today ? 'i dag' : DAY_LABELS[next.dayIndex].toLowerCase();
		return 'Lukket nu – åbner ' + when + ' kl. ' + clockFromMinutes(next.range.start);
	}

	Contenda.company = {
		settings: settings,
		escapeHtml: escapeHtml,
		telHref: telHref,
		phoneShort: phoneShort,
		addressLines: addressLines,
		mapsQuery: mapsQuery,
		mapsUrl: function () {
			return 'https://maps.google.com/?q=' + encodeURIComponent(mapsQuery());
		},
		mapsEmbedUrl: function () {
			return 'https://www.google.com/maps?q=' + encodeURIComponent(mapsQuery()) + '&z=16&output=embed';
		},
		phone: function () {
			return settings().company_phone || '';
		},
		email: function () {
			return settings().company_email || '';
		},
		weekdaySummary: weekdaySummary,
		isOpen: isOpen,
		hoursList: hoursList,
		openStatus: openStatus,
		openDays: openDays,
		heroMeta: heroMeta,
		fillContact: function ($root) {
			var phone = Contenda.company.phone();
			var email = Contenda.company.email();
			$root.find('.js-company-phone').each(function () {
			var $el = $(this);
			$el.attr('href', telHref(phone));
			if (!$el.attr('data-keep-label')) $el.text(phone);
		});
		$root.find('.js-company-email').each(function () {
			var $el = $(this);
			$el.attr('href', 'mailto:' + email);
			if (!$el.attr('data-keep-label')) $el.text(email);
		});
			$root.find('.js-company-phone-text').text(phone);
			$root.find('.js-company-phone-short').text(phoneShort(phone));
			$root.find('.js-company-email-text').text(email);
		}
	};
})(window);
